/// <reference path="../app.js"/>

$(".FilmCarousel.element .track").each((_index, element) => {
	/**
	 * @type {"none" | "mousedown" | "dragging"}
	 */
	let dragState = "none";
	let currTransform = 0;
	let momentum = 0;
	let prevClientX = -1;

	const carousel = $(element).parent();
	const track = $(element);
	const trackWidth = (track.children().length) * 256;

	function addClones() {
		const reqFilms = (Math.max(Math.round(window.innerWidth / 256) * 2), 600) - track.children().filter(":not(.close)").length;

		if (reqFilms <= 0) return;

		track.find(".clone").remove();

		for (let i = 0; i < reqFilms; i++) {
			const film = $(track.children()[i]);

			film.clone().addClass("clone").appendTo(film.parent());
		}
	}

	function updateTransform() {

		if (dragState !== "dragging") {
			momentum *= .9;
			currTransform += momentum;
		}

		if (currTransform <= -trackWidth) currTransform += trackWidth;
		if (currTransform >= 0) currTransform -= trackWidth;

		if (dragState !== "dragging") currTransform -= 0.2;

		track.css("transform", `translateX(${currTransform}px)`);

		window.requestAnimationFrame(updateTransform);
	}
	
	carousel.on("mousedown touchstart", event => {
		dragState = "mousedown";

		if (event.type === "touchstart") prevClientX = -1;
	});

	carousel.on("mousemove touchmove", event => {
		const clientX = event.type === "touchmove" ? event.touches[event.touches.length - 1].clientX : event.clientX;

		if (dragState === "mousedown") dragState = "dragging";

		if (dragState === "dragging") {
			momentum = prevClientX === -1 ? 0 : clientX - prevClientX;
			currTransform += momentum;
		}

		prevClientX = clientX;
	});

	carousel.on("mouseleave", () => {
		dragState = "none";
	});

	carousel.on("mouseup touchend", () => {
		dragState = "none";
	});

	$(window).on("resize", () => addClones());

	addClones();
	updateTransform();
});